import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(
    private router: Router) {
  }
  // getLocationDetail(request: google.maps.GeocoderRequest): Promise<any> {
  //   let geocoder: google.maps.Geocoder = new google.maps.Geocoder();
  //   return new Promise((resolve, reject) => {
  //     geocoder.geocode(request, (res, status) => {
  //       if (status === 'OK') {
  //         resolve(res[0].address_components);
  //         // let postal_code = res[0].address_components.find(f => f.types.find(t => t === 'postal_code'));
  //         // if (postal_code) {
  //         //   resolve(postal_code.long_name);
  //         // }
  //       }
  //       else {
  //         reject(null);
  //       }
  //     })
  //   });
  // }
  getLocationDetail(request: any): Promise<any> {
    return new Promise((resolve, reject) => {
      fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${request}&key=${environment.googleMapKey}`).then(response => response.json())
        .then(result => {
          if (result.status === 'OK') {
            let res = result.results.find((f: any) => f.address_components.find((ff: any) => ff.types[0] == 'country' && ff.short_name == 'CA'));
            if (res.address_components) {
              resolve({ address_components: res.address_components, formatted_address: res.formatted_address });
            }
            else {
              reject(null);
            }
          }
          else {
            reject(null);
          }
        })
        .catch(error => {
          reject(null);
        });
    });
  }

}
